import React from 'react'
import buttbotLogo from '../images/buttbot-icon.png'

const ButtBotLogo = () => <img src={buttbotLogo} alt="ButtBot" className="float-effect" />
export default ButtBotLogo
